;(function () {
  'use strict'

  angular.module('deskfy.core').directive('coreTableColumnRowUserStatus', tableColumnRowUserStatus)

  /* @ngInject */
  function tableColumnRowUserStatus () {
    return {
      restrict: 'E',
      scope: {
        value: '<',
        id: '<',
        removedAt: '<?',
        changeLoading: '<'
      },
      controller: 'TableColumnRowUserStatusController',
      templateUrl:
        '/core/directives/table-columns/table-column-row-user-status/table-column-row-user-status-directive.html?$$REVISION$$',
      link: function ($scope) {
        $scope.status = getTagContent($scope.value)

        function getTagContent (value) {
          const tagContent = {
            ACTIVE: { label: 'activeUser', type: 'green' },
            INACTIVE: { label: 'inactiveUser', type: 'grey' },
            PENDING_INVITE: { label: 'pending', type: 'orange' },
            REMOVED: { label: 'removedUser', type: 'red' }
          }

          if (tagContent[value]) return tagContent[value]

          return tagContent.PENDING_INVITE
        }
      }
    }
  }
})()
